// Returns true only when dimensions represent a valid square image.
export const canSaveSquareTemplate = (
  width: unknown,
  height: unknown
): boolean => {
  const w = Number(width);
  const h = Number(height);
  if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) {
    return true;
  }
  return Math.abs(w / h - 1) <= 0.001;
};

// Builds next template name from highest numbered "template N" item.
export const getNextTemplateName = (
  templateArray: Array<{ name?: string }> = []
): string => {
  let highestNumber = 0;

  if (templateArray?.length > 0) {
    templateArray.forEach((template) => {
      const templateNumber = parseInt(
        String(template.name || "").split(" ")[1] || "0",
        10
      );
      if (!isNaN(templateNumber) && templateNumber > highestNumber) {
        highestNumber = templateNumber;
      }
    });
  }

  return `template ${highestNumber + 1}`;
};

// Save template media as true 1:1 by center-cropping the longer side.
// This avoids transparent padding/extra empty space.
export const squareThumbnailPreview = async (downloadState: { Image: string }) => {
  return new Promise<string>((resolve) => {
  const image = new window.Image();
  image.onerror = () => resolve(downloadState.Image);
  image.onload = () => {
    try {
      const srcW = Math.max(1, image.naturalWidth || image.width || 1);
      const srcH = Math.max(1, image.naturalHeight || image.height || 1);
      const side = Math.min(srcW, srcH);
      const cropX = Math.max(0, Math.round((srcW - side) / 2));
      const cropY = Math.max(0, Math.round((srcH - side) / 2));
      const canvas = document.createElement("canvas");
      canvas.width = side;
      canvas.height = side;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        resolve(downloadState.Image);
        return;
      }
      ctx.clearRect(0, 0, side, side);
      ctx.drawImage(image, cropX, cropY, side, side, 0, 0, side, side);
      resolve(canvas.toDataURL("image/png"));
    } catch {
      resolve(downloadState.Image);
    }
  };
  image.src = downloadState.Image;
})
};
